import React, { useState } from 'react'
import { Alert, Button, Container } from 'react-bootstrap'
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import CustomModal from '../CustomModal/CustomModal';

function RegistrationConditionsContainer() {
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const [modalShow, setModalShow] = useState(false);
  const [isAccepted, setIsAccepted] = useState(false);
  return (
    <div className='py-5 registration_conditionsContainer_container'>
      {modalShow &&
        <CustomModal
          show={modalShow}
          onHide={() => setModalShow(false)}

        />
      }
      <Container className='mt-5 pt-5'>
        <h3 className='text-center'>{currentLocal.home.registrationconditions}</h3>
        <p className='text-danger mt-4'>{currentLocal.home.registrationTermsTitle}</p>
        <div className='border-bottom pb-4 mb-4' style={{
          lineHeight: "38px"
        }}>
          {/* 1- لا يتم التسجيل إلا بالاطلاع على كافة تفاصيل التسجيل المدرسة.
          <br />
          2- يجب إرفاق جميع المستندات المطلوبة لتسجيل الطالب.
          <br />

          3- يلتزم الولي بتسجيل الطالب في البوابة التعليمية وتتابعه الإدارة في شرح عملية التسجيل إلى حين إتمامها.
          <br />

          4- يجب التوقيع على وثيقة التسجيل وملحق التعاقد المالي.
          <br />

          5- للمدرسة مواعيدها الخاصة المحددة من وزارة التربية والتعليم في بدء العام الدراسي وإجازة المنتصف ووقت نهاية العام الدراسي، وعليه يرجى من الولي التقيد بهذه المواعيد
          <br />

          6- لا يسمح بالغياب المتكرر من قبل الطالب، ولا تتحمل المدرسة أي تأخر تعليمي بسبب الغياب، وتستثنى من ذلك الحالات المرضية.
          <br />

          7- المدرسة غير مؤهلة لاستقبال طلاب ذوي حالات خاصة أو إعاقة عقلية أو بدنية، ومن ثبت لديه ذلك دون علم مسبق من الإدارة، فللإدارة الحق في اتخاذ الإجراء اللازم.
          <br />

          8- تتيح المؤسسة نقل الطالب بين فروعها في حالات ضرورية ومحدودة للغاية، وذلك حسب الشروط التالية :
          <br />

          * تحدد الإدارة ضرورة عملية النقل من عدمها، بعد النظر في المبررات المقدمة.
          <br />

          * أن لا تقل مدة النقل عن أسبوع دراسي.
          <br />

          * أن تكون المنطقة التي سينقل إليها الطالب ضمن خريطة نقل المدرسة الذي سينقل إليها.
          <br />

          * في حال عدم توفر شاغر في الحافلة، يلتزم الولي بتوفير النقل خلال مدة نقل الطالب.
          <br />

          * لا تقبل قرارات النقل المفاجئة، ويجب إبلاغ إدارة المدرسة قبل أسبوع على الأقل من قرار النقل.
 */}

          <ol>
            {currentLocal.home.registrationTerms.map((term, index) => (
              <li key={index} dangerouslySetInnerHTML={{ __html: term }}></li>
            ))}
          </ol>

        </div>
        <h3 className='text-center'>{currentLocal.home.financialContractTitle}</h3>
        <div dangerouslySetInnerHTML={{ __html: currentLocal.home.financialContract }} />



        {/* <p
          style={{
            lineHeight: "38px"
          }}
        >


          <br />
          * الرسوم‭ ‬الدّراسيّة‭ ‬السنويّة، الموضحة  <Link to="/expenses"><span className='bg_main px-4 rounded py-1 text-white'>في الجدول التالي</span> </Link>.


          <br />
          * رسوم‭ ‬النّقل‭ ‬والمواصلات‭.

          <br />
          * رسوم‭ ‬الكتب‭ ‬والتّغذية‭.

          <br />
          <br />
          - يلتزم‭ ‬الطّرف‭ ‬الثاني‭ ‬بالانضباط‭ ‬في‭ ‬دفع‭ ‬الرّسوم‭ ‬الدّراسيّة‭ ‬بأحد‭ ‬الخيارات‭ ‬الآتية‭:‬

          <br />
          دفع الرسوم السنوية دفعة واحدة (قبل نهاية الفصل الدراسي الأول).

          <br />
          دفع الرسوم السنوية على دفعتين (الفصل الأول والفصل الثاني).
          <br />
          دفع الرسوم السنوية بدفعات شهرية.
          <br />
          - في‭ ‬حال‭ ‬اختيار‭ ‬الطّرف‭ ‬الثاني‭ ‬لأحد‭ ‬الخيارات‭ ‬الواردة‭ ‬أعلاه؛‭ ‬يلتزم‭ ‬التزاما‭ ‬كاملا‭ ‬بالإيفاء‭ ‬بالالتزام‭ ‬والانضباط‭ ‬في‭ ‬الدّفع‭ ‬حسب‭ ‬الخيار‭ ‬المتّفق‭ ‬عليه‭ ‬بين‭ ‬الطّرفين‭.‬

          <br />


          - في‭ ‬حال‭ ‬تَأَخَّر‭ ‬الطّرف‭ ‬الثاني‭ ‬في‭ ‬سداد‭ ‬الرّسوم‭ ‬عن  ‬المحدّد‭ ‬له‭ ‬حسب‭ ‬الخيار‭ ‬المتّفق‭ ‬عليه؛‭ ‬يكون‭ ‬من‭ ‬حقّ‭ ‬الطرف‭ ‬الأوّل‭ ‬مُطالبته‭ ‬في‭ ‬الإيفاء‭ ‬بالالتزام،‭ ‬ومُتابعته‭ ‬بكلّ‭ ‬الوسائل‭ ‬المتاحة‭ ‬له‭.‬
          <br />

          - إذا‭ ‬فقد‭ ‬الطّالب‭ ‬كتبه‭ ‬الدراسيّة‭ ‬أو‭ ‬أيّ‭ ‬وثيقة‭ ‬تُسلّم‭ ‬له‭ ‬من‭ ‬المدرسة؛‭ ‬يُطلب‭ ‬منه‭ ‬دفع‭ ‬مُستحقّات‭ ‬البديل‭ ‬الذي‭ ‬سيوفّر‭ ‬له‭ ‬تعويضا‭ ‬له‭ ‬عن‭ ‬الوثيقة‭ ‬المفقودة‭.‬
          <br />

          - يُحظر‭ ‬حظرا‭ ‬قاطعا،‭ ‬ويمنع‭ ‬منعا‭ ‬باتّا‭ ‬انسحاب‭ ‬الطّالب‭ ‬من‭ ‬المدرسة‭ ‬بعد‭ ‬حجز‭ ‬المقعد‭ ‬له،‭ ‬إلاّ‭ ‬في‭ ‬حالات‭ ‬الضّرورة‭ ‬القُصوى‭ ‬كالسّفر‭ ‬أو‭ ‬المرض‭‬،‭ ‬مع‭ ‬تقديم‭ ‬الإثبات‭ ‬الرسميّ‭ ‬للضّرورة‭ ‬الواقعة‭.‬
          <br />

          - يُعتبر‭ ‬مبلغ‭ ‬حجز‭ ‬المقعد‭ ‬(مُقدّم‭ ‬الدّفع)‭ ‬حَقًّا‭ ‬ثابتا‭ ‬للمُؤسّسة‭ ‬لا‭ ‬يُسترجع‭ ‬ولا‭ ‬يُستردّ‭ ‬في‭ ‬حال‭ ‬الانسحاب‭.‬
          <br />

          - يلتزم‭ ‬ولي‭ ‬الأمر‭ ‬بدفع‭ ‬الرسوم‭ ‬الدراسيّة‭ ‬السنويّة‭ ‬كاملة‭ ‬ـ‭ ‬إلى‭ ‬نهاية‭ ‬السنة‭ ‬الدراسية‭ ‬ـ؛‭ ‬في‭ ‬حال‭ ‬انسحاب‭ ‬الطَّالب‭ ‬بعد‭ ‬انطلاق‭ ‬الدراسة‭ ‬وبدايتها‭.‬
          <br />

          - يلتزم‭ ‬الطّرف‭ ‬الثاني‭ ‬بدفع‭ ‬الرّسوم‭ ‬الدراسيّة‭ ‬عن‭ ‬طريق‭ ‬الحساب‭ ‬البنكي‭ ‬للمدرسة‭ ‬(الفرع)‭‬،‭ ‬ولا‭ ‬يستقبل‭ ‬الطّرف‭ ‬الثاني‭ ‬المبالغ‭ ‬المالية‭ ‬بالدّفع‭ ‬اليدويّ‭.
          <br />

          - يعتمد‭ ‬الطّرف‭ ‬الأوّل‭ ‬إجراءاتٍ‭ ‬داخليّةً‭ ‬في‭ ‬حال‭ ‬تأخّر‭ ‬الطّرف‭ ‬الثّاني‭ ‬عن‭ ‬الدّفع‭ ‬لمدّة‭ ‬ثلاثة‭ ‬أشهر‭ ‬دون‭ ‬اتّفاق‭ ‬مُسبق‭ ‬مع‭ ‬الإدارة‭ ‬مُتمثّلة‭ ‬في‭ ‬الآتي‭: ‬توقيف‭ ‬خدمة‭ ‬النّقل،‭ ‬عدم‭ ‬تسليم‭ ‬الشّهادات‭ ‬والكُشوف‭... ‬إلخ‭.‬
          <br />

          - يعتمد‭ ‬الطّرف‭ ‬الأوّل‭ ‬في‭ ‬حال‭ ‬التعليم‭ ‬الْمُباشر،‭ ‬والدوام‭ ‬العادي‭ ‬وفقا‭ ‬للرّزنامة‭ ‬المقرَّرة‭ ‬مِن‭ ‬وزارة‭ ‬التربية‭ ‬(القرار‭ ‬الوزاري‭ ‬رقم‭ ‬194-(2021‭ ‬والتواريخ ‭ ‬المحدّدة‭ ‬تحصيل‭ ‬الرّسوم‭ ‬السنويّة‭ ‬كاملة‭ ‬حسب‭ ‬التفصيل‭ ‬المبيّن  <Link to="/expenses"><span className='bg_main px-4 rounded py-1 text-white'>في الجدول التالي</span> </Link> .
          <br />

          - تعتبر‭ ‬الإجازات‭ ‬الرسمية‭ ‬ـ‭ ‬خلال‭ ‬العام‭ ‬الدراسيّ‭ ‬ـ‭ ‬المقرّرة‭ ‬من‭ ‬قِبَل‭ ‬وزارة‭ ‬التّربية‭ ‬والتعليم‭ ‬من‭ ‬ضمن‭ ‬الأيام‭ ‬الدراسيّة‭ ‬المعتمدة،‭ ‬وتستمرّ‭ ‬الرسوم‭ ‬الدراسيّة‭ ‬خلالها‭ ‬دون‭ ‬أيّ‭ ‬انقطاع،‭ ‬ويلتزم‭ ‬الطّرف‭ ‬الثّاني‭ ‬بدفع‭ ‬المستحقّات‭ ‬كاملةً‭.



        </p> */}
        {/* <h5 className='fw-bold'>
{currentLocal.home.directLearningPaymentTitle}
        </h5> */}
        {/* {currentLocal.home.directLearningPayment.map((term, index) => (
          <p key={index} dangerouslySetInnerHTML={{ __html: term }}></p>
        ))} */}
        {/*       
      <h5 className='fw-bold'>
{currentLocal.home.distanceLearningPaymentTitle}
        </h5> */}
        {/* <p
          style={{
            lineHeight: "38px"
          }}
        >
                  {currentLocal.home.distanceLearningPayment.map((term, index) => (
          <li key={index} dangerouslySetInnerHTML={{ __html: term }}></li>
        ))}

        </p> */}
        <div className='my-4 d-flex align-items-center gap-2'>
          <input
            id="termsCheckbox"
            type="checkbox"
            checked={isAccepted}
            onChange={(e) => setIsAccepted(e.target.checked)}
          />

          <label htmlFor="termsCheckbox" className="mb-0 fs-6 fw-bold" style={{ cursor: "pointer" }}>
            {currentLocal.language === "English"
              ? "I agree to the terms and conditions"
              : "أوافق على الشروط والأحكام"}
          </label>
        </div>

        <div className='mt-4 d-flex justify-content-center w-100 '>
          <Button variant='success' className='py-3 w-50'
            onClick={() => {
              if(!isAccepted){
alert("برجاء الموافقة علي الشروط والأحكام")
              }else{
                setModalShow(true)
              }
            }}
          >
            {currentLocal.home.acknowledge}
          </Button>
        </div>
      </Container>
    </div>
  )
}

export default RegistrationConditionsContainer